import { create_fetchers } from 'zylo_schema/src/create_fetchers';

const base_url = 'https://joinzylo.com';
const fetchers = create_fetchers(base_url);
export default fetchers;
